import { TextInput as MantineTextInput } from "@mantine/core";
import type { InputProps } from "../../types";

export const LiteralView = ({ value }: InputProps<string>) => {
  return <MantineTextInput value={value} disabled />;
};
